'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveOffer = exports.planById = exports.plansByMsa = exports.livePlanById = exports.livePlansByMsa = exports.livePlans = undefined;

var _sagaTools = require('@classpass/saga-tools');

var livePlans = exports.livePlans = (0, _sagaTools.makeEntityScaffold)('SAGA.API.LIVE_PLANS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return client.plans.getLive(options).then(function (res) {
    return res.data;
  });
}); /* eslint-disable import/prefer-default-export */

var livePlansByMsa = exports.livePlansByMsa = (0, _sagaTools.makeEntityScaffold)('SAGA.API.LIVE_PLANS_BY_MSA', function (client, msaId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.plans.getLiveByMsa(msaId, options).then(function (res) {
    return res.data;
  });
}, { defaultKey: 1 });

var livePlanById = exports.livePlanById = (0, _sagaTools.makeEntityScaffold)('SAGA.API.LIVE_PLAN_BY_ID', function (client, planId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.plans.getLiveById(planId, options).then(function (res) {
    return res.data;
  });
}, { defaultKey: 1 });

var plansByMsa = exports.plansByMsa = (0, _sagaTools.makeEntityScaffold)('SAGA.API.PLANS', function (client, msaId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.plans.getByMsaV3(msaId, options).then(function (data) {
    return data.plans;
  });
}, { defaultKey: 1 });

var planById = exports.planById = (0, _sagaTools.makeEntityScaffold)('SAGA.API.PLAN_BY_ID', function (client, planId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.plans.getByIdV2(planId, options);
}, { defaultKey: 1 });

var saveOffer = exports.saveOffer = (0, _sagaTools.makeEntityScaffold)('SAGA.API.SAVE_OFFER', function (client, userId) {
  return client.plans.getUserSaveOffer(userId);
});